import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateId } from '@ztechapps/common.utils'

@ObjectType()
export class InvoiceItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateId() })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  name: string

  @Field(() => String)
  @Prop({ type: String })
  description: string

  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  @Field(() => Float)
  @Prop({ type: Number })
  order: number

  @Field(() => Float)
  @Prop({ type: Number })
  backOrder: number

  @Field(() => Float)
  @Prop({ type: Number })
  price: number

  @Field(() => Float)
  @Prop({ type: Number })
  grossAmount: number

  @Field(() => Float)
  @Prop({ type: Number })
  discountPercent: number

  @Field(() => Float)
  @Prop({ type: Number })
  discountAmount: number

  @Field(() => Float)
  @Prop({ type: Number })
  amount: number
}
